import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useLocationData } from "@/hooks/useLocationData";
import { isPathActive, navForWorkspace } from "@/lib/nav";
import { useAuthStore } from "@/stores/authStore";
import { AppSidebar, type AppNavEntry } from "./app-sidebar";

/**
 * The console's adapter over AppSidebar: only DATA lives here (the nav
 * table, the unread badge, sign-out). Everything visual is in AppSidebar.
 */
export function ConsoleSidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const signOut = useAuthStore((s) => s.signOut);
  const data = useLocationData();
  const unreadCount = data.listAlerts({ status: "open" }).length;
  const kind = data.workspace.id === "personal" ? "personal" : "team";

  const entries: AppNavEntry[] = useMemo(
    () =>
      navForWorkspace(kind).map((e) =>
        !("type" in e) && e.key === "alerts" ? { ...e, badge: unreadCount } : e,
      ),
    [unreadCount, kind],
  );

  return (
    <AppSidebar
      entries={entries}
      isActive={(href) => isPathActive(href, location.pathname)}
      onSignOut={async () => {
        await signOut();
        navigate("/signin?signout=true", { replace: true });
      }}
      homeHref="/map"
      defaultMode="expanded"
    />
  );
}
